import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface EnableLinkCriteria {
    id: string;
    dashboardId: string;
    locationId: string;
    active: boolean;
}

class EnableLinkCriteriaImpl implements EnableLinkCriteria {
    constructor(readonly id: string, readonly dashboardId: string, readonly locationId: string, readonly active: boolean) {}
}

export class EnableLinkCriteriaBuilder {
    private id: Option<string> = none;

    private dashboardId: Option<string> = none;

    private locationId = '';

    private active: Option<boolean> = none;

    static create = (): EnableLinkCriteriaBuilder => new EnableLinkCriteriaBuilder();

    withId = (id: string): EnableLinkCriteriaBuilder => {
        this.id = some(id);
        return this;
    };

    withDashboardId = (dashboardId: string): EnableLinkCriteriaBuilder => {
        this.dashboardId = some(dashboardId);
        return this;
    };

    withLocationId = (locationId: string): EnableLinkCriteriaBuilder => {
        this.locationId = locationId;
        return this;
    };

    withActive = (active: boolean): EnableLinkCriteriaBuilder => {
        this.active = some(active);
        return this;
    };

    build = (): EnableLinkCriteria => {
        if (isNone(this.id) || isNone(this.dashboardId) || this.locationId === '' || isNone(this.active)) {
            throw new ReferenceError('Undefined prop');
        }

        return new EnableLinkCriteriaImpl(this.id.value, this.dashboardId.value, this.locationId, this.active.value);
    };
}
